import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import ServicesViewPage from 'pages/services/View';
import StaffViewPage from 'pages/staff/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import UsersViewPage from 'pages/users/View';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const BookingsListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/bookings/view/${data.id}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('bookings/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/bookings/edit/${data.id}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('bookings/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.id) },
			icon: "pi pi-trash",
			visible: () => auth.canView('bookings/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function IdTemplate(data){
		if(data){
			return (
				<Link to={`/bookings/view/${data.id}`}> { data.id }</Link>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{data.userid && <Button className="p-button-text" icon="pi pi-eye" label="Users" onClick={() => app.openPageDialog(<UsersViewPage isSubPage apiPath={`/users/view/${data.userid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function ServiceidTemplate(data){
		if(data){
			return (
				<>{data.serviceid && <Button className="p-button-text" icon="pi pi-eye" label="Services" onClick={() => app.openPageDialog(<ServicesViewPage isSubPage apiPath={`/services/view/${data.serviceid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PickupdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.pickupdate )}</>
			);
		}
	}
	function DeliverydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.deliverydate )}</>
			);
		}
	}
	function AssignedstaffidTemplate(data){
		if(data){
			return (
				<>{data.assignedstaffid && <Button className="p-button-text" icon="pi pi-eye" label="Staff" onClick={() => app.openPageDialog(<StaffViewPage isSubPage apiPath={`/staff/view/${data.assignedstaffid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function AssigneddriveridTemplate(data){
		if(data){
			return (
				<>{data.assigneddriverid && <Button className="p-button-text" icon="pi pi-eye" label="Staff" onClick={() => app.openPageDialog(<StaffViewPage isSubPage apiPath={`/staff/view/${data.assigneddriverid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function CancelledbyTemplate(data){
		if(data){
			return (
				<>{data.cancelledby && <Button className="p-button-text" icon="pi pi-eye" label="Users" onClick={() => app.openPageDialog(<UsersViewPage isSubPage apiPath={`/users/view/${data.cancelledby}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function CreatedbyTemplate(data){
		if(data){
			return (
				<>{data.createdby && <Button className="p-button-text" icon="pi pi-eye" label="Users" onClick={() => app.openPageDialog(<UsersViewPage isSubPage apiPath={`/users/view/${data.createdby}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function ModifiedbyTemplate(data){
		if(data){
			return (
				<>{data.modifiedby && <Button className="p-button-text" icon="pi pi-eye" label="Users" onClick={() => app.openPageDialog(<UsersViewPage isSubPage apiPath={`/users/view/${data.modifiedby}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="bookings/delete">
		<MultiDelete />
	</CanView>
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="BookingsListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Bookings"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/bookingquick`}>
                        <Button label="Add New Booking" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="id" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="id" header="Id" body={IdTemplate} sortable={true} ></Column>
                                    <Column  field="bookingreference" header="Booking Reference"  sortable={true} ></Column>
                                    <Column  field="userid" header="Userid" body={UseridTemplate} sortable={true} ></Column>
                                    <Column  field="serviceid" header="ServiceID" body={ServiceidTemplate} sortable={true} ></Column>
                                    <Column  field="partnerid" header="PartnerID"  sortable={true} ></Column>
                                    <Column  field="status" header="Status"  sortable={true} ></Column>
                                    <Column  field="pickupdate" header="Pickup Date" body={PickupdateTemplate} sortable={true} ></Column>
                                    <Column  field="deliverydate" header="Delivery Date" body={DeliverydateTemplate} sortable={true} ></Column>
                                    <Column  field="pickuptimeslot" header="Pickup Timeslot"   ></Column>
                                    <Column  field="deliverytimeslot" header="Delivery Timeslot"   ></Column>
                                    <Column  field="pickupaddress" header="Pickup Address"   ></Column>
                                    <Column  field="deliveryaddress" header="Delivery Address"   ></Column>
                                    <Column  field="pickuplatitude" header="Pickup Latitude"   ></Column>
                                    <Column  field="pickuplongitude" header="Pickup Longitude"   ></Column>
                                    <Column  field="deliverylatitude" header="Delivery Latitude"   ></Column>
                                    <Column  field="deliverylongitude" header="Delivery Longitude"   ></Column>
                                    <Column  field="totalweight" header="Total Weight"   ></Column>
                                    <Column  field="totalitems" header="Total Items"   ></Column>
                                    <Column  field="baseamount" header="Base Amount"   ></Column>
                                    <Column  field="weightcharge" header="Weight Charge"   ></Column>
                                    <Column  field="extracharges" header="Extra Charges"   ></Column>
                                    <Column  field="discountamount" header="Discount Amount"   ></Column>
                                    <Column  field="taxrate" header="Taxrate"   ></Column>
                                    <Column  field="taxamount" header="Taxamount"   ></Column>
                                    <Column  field="totalamount" header="Total Aamount"   ></Column>
                                    <Column  field="specialinstructions" header="Special Instructions"   ></Column>
                                    <Column  field="preferredcontactmethod" header="Preferredcontactmethod"   ></Column>
                                    <Column  field="deliveryinstructions" header="Deliveryinstructions"   ></Column>
                                    <Column  field="paymentstatus" header="Payment Status"   ></Column>
                                    <Column  field="paymentmethod" header="Payment Method"   ></Column>
                                    <Column  field="transactionid" header="Transactionid"   ></Column>
                                    <Column  field="paymentdate" header="Payment Date"   ></Column>
                                    <Column  field="assignedstaffid" header="Assignedstaffid" body={AssignedstaffidTemplate}  ></Column>
                                    <Column  field="assigneddriverid" header="Assigneddriverid" body={AssigneddriveridTemplate}  ></Column>
                                    <Column  field="createdat" header="Createdat"   ></Column>
                                    <Column  field="updatedat" header="Updatedat"   ></Column>
                                    <Column  field="confirmedat" header="Confirmedat"   ></Column>
                                    <Column  field="pickedupat" header="Pickedupat"   ></Column>
                                    <Column  field="processingstartedat" header="Processingstartedat"   ></Column>
                                    <Column  field="readyfordeliveryat" header="Readyfordeliveryat"   ></Column>
                                    <Column  field="outfordeliveryat" header="Outfordeliveryat"   ></Column>
                                    <Column  field="deliveredat" header="Deliveredat"   ></Column>
                                    <Column  field="completedat" header="Completedat"   ></Column>
                                    <Column  field="cancelledat" header="Cancelledat"   ></Column>
                                    <Column  field="cancelledreason" header="Cancelledreason"   ></Column>
                                    <Column  field="cancelledby" header="Cancelledby" body={CancelledbyTemplate}  ></Column>
                                    <Column  field="customerrating" header="Customerrating"   ></Column>
                                    <Column  field="customerreview" header="Customerreview"   ></Column>
                                    <Column  field="reviewdate" header="Reviewdate"   ></Column>
                                    <Column  field="isurgent" header="Isurgent"   ></Column>
                                    <Column  field="prioritylevel" header="Prioritylevel"   ></Column>
                                    <Column  field="isrepeatcustomer" header="Isrepeatcustomer"   ></Column>
                                    <Column  field="source" header="Source"   ></Column>
                                    <Column  field="createdby" header="Createdby" body={CreatedbyTemplate}  ></Column>
                                    <Column  field="modifiedby" header="Modifiedby" body={ModifiedbyTemplate}  ></Column>
                                    <Column  field="date_created" header="Date Created"   ></Column>
                                    <Column  field="date_updated" header="Date Updated"   ></Column>
                                    <Column  field="pickupconfirmedby" header="Pickupconfirmedby"   ></Column>
                                    <Column  field="deliveryconfirmedby" header="Deliveryconfirmedby"   ></Column>
                                    <Column  field="paymentid" header="Paymentid"   ></Column>
                                    <Column  field="quantity" header="Quantity"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
BookingsListPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'bookings',
	apiPath: 'bookings/index',
	routeName: 'bookingslist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default BookingsListPage;
